import AdsError from './AdsError.js'

export default class InvalidSearchRequestError extends AdsError {}
